export default __webpack_public_path__ + "static/media/logo_mc.542e9871.png";